import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsProps,
} from "@chakra-ui/react";
import React from "react";
import { useSearchParams } from "react-router-dom";

interface TabConfig<KEY extends string> {
  label: string;
  key: KEY;
  isVisible: boolean;
  panel: React.ReactNode;
}

interface Props<KEY extends string> extends Omit<TabsProps, "children"> {
  tabs: readonly TabConfig<KEY>[];
}
export function TabsWithSearchParams<KEY extends string>({
  tabs,
  ...props
}: Props<KEY>) {
  const [searchParams, setSearchParams] = useSearchParams();
  const index = tabs.findIndex((tab) => tab.key === searchParams.get("tab"));
  const onChange = React.useCallback(
    (index: number) => {
      const key = tabs[index]?.key;
      if (!key) {
        return;
      }
      searchParams.set("tab", key);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams, tabs]
  );

  return (
    <Tabs onChange={onChange} index={index > 0 ? index : 0} {...props}>
      <TabList>
        {tabs.map(
          (tab) => tab.isVisible && <Tab key={tab.key}>{tab.label}</Tab>
        )}
      </TabList>
      <TabPanels>
        {tabs.map(
          (tab) =>
            tab.isVisible && <TabPanel key={tab.key}>{tab.panel}</TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
}
